module.exports = __webpack_public_path__ + "img/mandate-failure.97c0fe96.svg";